import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { InvoiceTemplateStateClass } from "./interfaces/invoicetemplateStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: InvoiceTemplateStateClass = {
    isLoading: false,
    status: 'idle',
    invoicetemplateList: [],
    selectedRecord: {},
    isReload: false,
    pageNo: 1,
    search: '',
    pageSize: 10,
    sortOrder: 'asc',
    sortColumn: 'AccountLocation'
}


interface IThunkApi {
    state: {
        invoiceTemplate: InvoiceTemplateStateClass;
    },
}

export const getAccountInvoiceTemplateAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'invoicetemplate/getAccountInvoiceTemplate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/InvoiceTemplate', 'Get', '', true, '0c077428-c7f6-499f-b985-fc9f4740aea9');
            const json = await response.json();
            return json;
        }
    )

export const getInvoiceTemplateByInvoiceTemplateIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "invoicetemplate/v2/getAccountInvoiceTemplateByInvoiceTemplateId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/InvoiceTemplate/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addInvoiceTemplateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "invoicetemplate/addInvoiceTemplate",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/InvoiceTemplate/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateInvoiceTemplateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "invoicetemplate/v2/updateInvoiceTemplate",
        async (arg, thunkApi) => {
            const { AccountInvoiceTemplateId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/InvoiceTemplate/" + AccountInvoiceTemplateId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const deleteInvoiceTemplateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "invoicetemplate/v2/deleteInvoiceTemplate",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/InvoiceTemplate/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const invoiceTemplateSlice = createSlice({
    name: 'invoiceTemplate',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        updateLoaderState: (state, action)=>{
            state.isLoading = action.payload
        },
         updatePagination: (state, action: PayloadAction<any>) => {
                    state.pageSize = action.payload.pageSize;
                    state.pageNo = action.payload.pageNo;
                    state.search = action.payload.search;
                },
                updateSorting: (state, action) => {
                    state.sortOrder = action.payload.sortOrder;
                    state.sortColumn = action.payload.sortColumn;
                    state.pageSize = action.payload.pageSize;
                    state.pageNo = action.payload.pageNo;
                    let tempArray = state.invoicetemplateList;
                    state.invoicetemplateList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
                }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountInvoiceTemplateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountInvoiceTemplateAsync.fulfilled, (state, { payload }) => {
                if (Object.keys(payload.Data).length === 0) {
                    state.invoicetemplateList = [];
                    state.isLoading = false;

                } else {
                    state.invoicetemplateList = payload.Data;
                    state.invoicetemplateList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountInvoiceTemplateAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getInvoiceTemplateByInvoiceTemplateIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getInvoiceTemplateByInvoiceTemplateIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data[0]).length === 0) {
                    state.selectedRecord = {};
                    state.isLoading = false;
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;
            })
            .addCase(getInvoiceTemplateByInvoiceTemplateIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addInvoiceTemplateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addInvoiceTemplateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addInvoiceTemplateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateInvoiceTemplateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateInvoiceTemplateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateInvoiceTemplateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteInvoiceTemplateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteInvoiceTemplateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteInvoiceTemplateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

    }
})

export const {
    resetSelectedRecordObjectInState, updatePagination, updateSorting, updateLoaderState
} = invoiceTemplateSlice.actions
export const InvoiceTemplateState = (state: RootState) => state.invoiceTemplate
export default invoiceTemplateSlice.reducer